// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartOutlinedSvg from "@fishx/icons-svg/es/asn/PieChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PieChartOutlined = function PieChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartOutlinedSvg
  }));
};

PieChartOutlined.displayName = 'PieChartOutlined';
export default React.forwardRef(PieChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PieChartOutlined.js
// module id = 3796
// module chunks = 0